"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const apis_1 = require("../../../networking/apis");
const scale_1 = require("../../../utils/scale");
const components_2 = require("../../Profile/UserProfile/components");
const BlockedView = (props) => {
    const { tweet } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const [user, setUser] = (0, react_1.useState)();
    const [isBlocking, setBlocking] = (0, react_1.useState)(false);
    const [isBlocked, setBlocked] = (0, react_1.useState)(true);
    const [isMute, setMute] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        getUserDetail();
    }, []);
    const getUserDetail = () => {
        apis_1.UserApi.getUserDetailDashboard(tweet.userHandle)
            .then((response) => {
            setUser(response.data);
            setBlocking(response.data.is_blocking == 1);
            setBlocked(response.data.is_blocked == 1);
            setMute(response.data.is_muted == 1);
        })
            .catch((err) => {
            console.log(err);
        });
    };
    const toggleBlockUser = () => {
        (isBlocked ?
            apis_1.BasicApi.unblockUser(user?.user_id)
            :
                apis_1.BasicApi.blockUser(user?.user_id))
            .then(() => {
            dispatch(slice_1.default.actions.showToast(isBlocked ? 'ブロック解除しました' : 'ブロックしました'));
            setBlocked(!isBlocked);
        })
            .catch((err) => {
            console.log(err);
        });
    };
    const toggleMuteUser = () => {
        (isMute ?
            apis_1.BasicApi.unMuteUser(user?.user_id)
            :
                apis_1.BasicApi.muteUser(user?.user_id))
            .then(() => {
            dispatch(slice_1.default.actions.showToast(isMute ? 'ミュート解除しました' : 'ミュートしました'));
            setMute(!isMute);
        })
            .catch((err) => {
            console.log(err);
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'タイムライン', styleContainer: {
                backgroundColor: Colors_1.default.white,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#21242D' }), onLeftPress: rootNavigation_1.goBack }),
        !!user && (react_1.default.createElement(react_native_1.ScrollView, { style: styles.body, contentContainerStyle: {
                paddingBottom: inset.bottom + (0, scale_1.scale)(100),
            }, showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.Pressable, { disabled: !user.header_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, { uri: user.header_url }) },
                react_1.default.createElement(react_native_1.Image, { source: user?.header_url ? { uri: user.header_url } : images_1.images.NoImages, resizeMode: "cover", style: styles.backgroundImage })),
            react_1.default.createElement(react_native_1.View, { style: styles.userInfo },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.row,
                        {
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                        },
                    ] },
                    react_1.default.createElement(react_native_1.Pressable, { disabled: !user.thumbnail_url, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, {
                            uri: user.image_url,
                        }) },
                        react_1.default.createElement(react_native_1.Image, { source: user?.thumbnail_url
                                ? { uri: user.thumbnail_url }
                                : images_1.images.AvatarDefaul, resizeMode: "cover", style: styles.avatar })),
                    react_1.default.createElement(components_2.SubUserButton, { user: user, isBlocking: isBlocking, isBlocked: isBlocked, isMute: isMute, toggleBlockUser: toggleBlockUser, toggleMuteUser: toggleMuteUser })),
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.row,
                        {
                            alignItems: 'center',
                            marginTop: (0, scale_1.scale)(8),
                        },
                    ] },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.fullName }, user?.nickname)),
                react_1.default.createElement(CustomText_1.default, { style: styles.username },
                    "@",
                    user?.user_handle),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles.blockTitle }, `@${user?.user_handle || ''}さん${isBlocked ? 'を' : 'は'}\n${isBlocked ? 'ブロックしました' : 'あなたをブロックしました'}`),
                react_1.default.createElement(CustomText_1.default, { style: styles.blockDescription }, `@${user?.user_handle || ''}${isBlocked
                    ? 'さんをブロックしているため'
                    : 'さんにブロックされているため'}\n@${user?.user_handle || ''}${isBlocked
                    ? 'さんのコンテンツは表示されません。'
                    : 'さんのコンテンツを表示できません。'}`))))));
};
exports.default = BlockedView;
const styles = react_native_1.StyleSheet.create({
    row: {
        width: "100%",
        flexDirection: "row",
    },
    container: {
        flex: 1,
        width: "100%",
        backgroundColor: "#F7F7F7",
    },
    body: {
        flex: 1,
    },
    backgroundImage: {
        width: "100%",
        height: (0, scale_1.scale)(125),
    },
    userInfo: {
        width: "100%",
        paddingHorizontal: (0, scale_1.scale)(16),
    },
    avatar: {
        width: (0, scale_1.scale)(60),
        height: (0, scale_1.scale)(60),
        borderWidth: (0, scale_1.scale)(4),
        borderRadius: 999,
        borderColor: "#F7F7F7",
        marginTop: -(0, scale_1.scale)(16),
    },
    fullName: {
        marginRight: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: "#292A33",
    },
    username: {
        marginTop: (0, scale_1.scale)(4),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: "#7C7C7C",
    },
    settingButton: {
        width: (0, scale_1.scale)(32),
        height: (0, scale_1.scale)(32),
        borderWidth: (0, scale_1.scale)(1),
        borderRadius: (0, scale_1.scale)(3),
        borderColor: "#AAAAAA",
        justifyContent: "center",
        alignItems: "center",
    },
    followAnalyst: {
        width: "100%",
        marginTop: (0, scale_1.scale)(20),
        borderTopWidth: (0, scale_1.scale)(1),
        borderBottomWidth: (0, scale_1.scale)(1),
        borderColor: "#DDDDDD",
    },
    followItem: {
        flex: 1,
        padding: (0, scale_1.scale)(8),
        justifyContent: "center",
        alignItems: "center",
    },
    followItemLabel: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: "#292A33",
    },
    followItemValue: {
        marginTop: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: "#292A33",
    },
    introduce: {
        marginTop: (0, scale_1.scale)(20),
        fontSize: (0, scale_1.moderateScale)(14),
        lineHeight: (0, scale_1.moderateScale)(21),
        color: "#292A33",
    },
    introduceHashTag: {
        color: "#007AFF",
    },
    introduceVideo: {
        width: "100%",
        marginTop: (0, scale_1.scale)(12),
        height: (0, scale_1.scale)(192.94),
        backgroundColor: "black",
        borderRadius: (0, scale_1.scale)(8),
        overflow: "hidden",
    },
    locationText: {
        marginLeft: (0, scale_1.scale)(8),
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: "#545454",
    },
    date: {
        marginTop: (0, scale_1.scale)(12),
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: "#7C7C7C",
    },
    blockTitle: {
        width: "100%",
        marginTop: (0, scale_1.scale)(32),
        fontSize: (0, scale_1.moderateScale)(16),
        lineHeight: (0, scale_1.moderateScale)(24),
        color: "#292A33",
    },
    blockDescription: {
        width: "100%",
        marginTop: (0, scale_1.scale)(12),
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        color: "#292A33",
    },
});
